import { Component, OnDestroy, OnInit } from '@angular/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
import { CommonModule } from '@angular/common';
@AutoUnsubscribe()
@Component({
    selector: 'search-loading-placeholder',
    templateUrl: './search-loading-placeholder.component.html',
    imports:[
      CommonModule,
      LottieComponent
    ]
})
export class SearchLoadingPlaceholder implements OnInit, OnDestroy {
  questionContentAnimationOptions: AnimationOptions = {
    path: 'assets/images/lottie-img/question-content-animation.json',
  };
  constructor() {}
  ngOnInit(): void {}
  ngOnDestroy(): void {}
}
